import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue"

import {ref,} from "vue";
import ProductPrice from "@/shared/model/productPrice";
import ProductPriceCardComponent from "@/modules/OrganisationStructure/components/ProductPriceCardComponent.vue";
import SogFlexRow from "@/shared/ui/SogFlexRow.vue";
import SogCard from "@/shared/ui/SogCard.vue";
import SogCardTitle from "@/shared/ui/SogCardTitle.vue";
import {computed} from "vue";
import {ProductType} from "@/shared/model/productType";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import {TerritoryType} from "@/shared/model/territoryType";

interface Props {
  id?: string
  prices?: ProductPrice[]
  allowSelect?: boolean | string
  selected?: (item?: ProductPrice) => void,
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PriceListComponent',
  props: {
    id: { default: undefined },
    prices: { default: undefined },
    allowSelect: { type: [Boolean, String], default: undefined },
    selected: { type: Function, default: undefined }
  },
  setup(__props: any) {

const props = __props

const _selectedId = ref<string | undefined>(undefined)

function onClick(price: ProductPrice) {
  if (!props.allowSelect)
    return
  const res = _selectedId.value === price.id ? undefined : price
  _selectedId.value = res?.id
  if (props.selected) {
    props.selected(res)
  }
}

function isSelected(item: ProductPrice): boolean {
  return item.id === _selectedId.value
}

const _kzkIvkPrices = computed(() => {
  return props.prices?.filter(t => t.productTypeId === ProductType.Kzk && t.territoryTypeId === TerritoryType.Eu)
})
const _kzkGermanyPrices = computed(() => {
  return props.prices?.filter(t => t.productTypeId === ProductType.Kzk && t.territoryTypeId === TerritoryType.Germany)
})
const _exportPrices = computed(() => {
  return props.prices?.filter(t => t.productTypeId === ProductType.Zoll)
})
const _tzPrices = computed(() => {
  return props.prices?.filter(t => t.productTypeId === ProductType.Tz)
})

const _additionPrices = computed(() => {
  return props.prices?.filter(t => t.productTypeId === ProductType.Addition)
})

const _exportBlankPrices = computed(() => {
  return props.prices?.filter(t => t.productTypeId === ProductType.ExportBlank)
})

const _restPrices = computed(() => {
  return props.prices?.filter(t => ![ProductType.Addition, ProductType.Tz, ProductType.Zoll, ProductType.Kzk, ProductType.ExportBlank].some(p => p === t.productTypeId))
})


/*
watch(props,()=>{
    _tab.value?.hideTab(_tabIndexPurchase,!props.visiblePurchase)
    _tab.value?.hideTab(_tabIndexSale,!props.visibleSale)
    _salePrices.length = 0;
    _purchasePrices.length = 0;
    _salePrices.push(...props.salePrices??[])
    _purchasePrices.push(...props.purchasePrices??[])
  tabSelected(props.visiblePurchase?_tabIndexPurchase:_tabIndexSale)
},{immediate:true}
)
*/


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SogFlexRow, null, {
    default: _withCtx(() => [
      _withDirectives(_createVNode(SogCard, null, {
        default: _withCtx(() => [
          _createVNode(SogCardTitle, null, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createTextVNode(" Kurzzeitkennzeichen Deutschland ", -1)
            ]))]),
            _: 1
          }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_kzkGermanyPrices.value, (item) => {
            return (_openBlock(), _createBlock(SogCardContent, { key: item }, {
              default: _withCtx(() => [
                _createVNode(ProductPriceCardComponent, {
                  price: item,
                  "is-selected": isSelected(item),
                  "allow-select": __props.allowSelect,
                  onClick: ($event: any) => (onClick(item))
                }, null, 8, ["price", "is-selected", "allow-select", "onClick"])
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }, 512), [
        [_vShow, _kzkGermanyPrices.value.length]
      ]),
      _withDirectives(_createVNode(SogCard, null, {
        default: _withCtx(() => [
          _createVNode(SogCardTitle, null, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
              _createTextVNode(" Kurzzeitkennzeichen IVK ", -1)
            ]))]),
            _: 1
          }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_kzkIvkPrices.value, (item) => {
            return (_openBlock(), _createBlock(SogCardContent, { key: item }, {
              default: _withCtx(() => [
                _createVNode(ProductPriceCardComponent, {
                  price: item,
                  "is-selected": isSelected(item),
                  "allow-select": __props.allowSelect,
                  onClick: ($event: any) => (onClick(item))
                }, null, 8, ["price", "is-selected", "allow-select", "onClick"])
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }, 512), [
        [_vShow, _kzkIvkPrices.value.length]
      ]),
      _withDirectives(_createVNode(SogCard, null, {
        default: _withCtx(() => [
          _createVNode(SogCardTitle, null, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
              _createTextVNode(" Ausfuhrkennzeichen ", -1)
            ]))]),
            _: 1
          }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_exportPrices.value, (item) => {
            return (_openBlock(), _createBlock(SogCardContent, { key: item }, {
              default: _withCtx(() => [
                _createVNode(ProductPriceCardComponent, {
                  price: item,
                  "is-selected": isSelected(item),
                  "allow-select": __props.allowSelect,
                  onClick: ($event: any) => (onClick(item))
                }, null, 8, ["price", "is-selected", "allow-select", "onClick"])
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }, 512), [
        [_vShow, _exportPrices.value.length]
      ]),
      _withDirectives(_createVNode(SogCard, null, {
        default: _withCtx(() => [
          _createVNode(SogCardTitle, null, {
            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
              _createTextVNode(" Tageszulassung ", -1)
            ]))]),
            _: 1
          }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_tzPrices.value, (item) => {
            return (_openBlock(), _createBlock(SogCardContent, { key: item }, {
              default: _withCtx(() => [
                _createVNode(ProductPriceCardComponent, {
                  price: item,
                  "is-selected": isSelected(item),
                  "allow-select": __props.allowSelect,
                  onClick: ($event: any) => (onClick(item))
                }, null, 8, ["price", "is-selected", "allow-select", "onClick"])
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }, 512), [
        [_vShow, _tzPrices.value.length]
      ]),
      _withDirectives(_createVNode(SogCard, null, {
        default: _withCtx(() => [
          _createVNode(SogCardTitle, null, {
            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
              _createTextVNode(" Ausfuhrformulare ", -1)
            ]))]),
            _: 1
          }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_exportBlankPrices.value, (item) => {
            return (_openBlock(), _createBlock(SogCardContent, { key: item }, {
              default: _withCtx(() => [
                _createVNode(ProductPriceCardComponent, {
                  price: item,
                  "is-selected": isSelected(item),
                  "allow-select": __props.allowSelect,
                  onClick: ($event: any) => (onClick(item))
                }, null, 8, ["price", "is-selected", "allow-select", "onClick"])
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }, 512), [
        [_vShow, _exportBlankPrices.value.length]
      ]),
      _withDirectives(_createVNode(SogCard, null, {
        default: _withCtx(() => [
          _createVNode(SogCardTitle, null, {
            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
              _createTextVNode(" Gebühren ", -1)
            ]))]),
            _: 1
          }),
          _createVNode(SogCardContent, null, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_additionPrices.value, (item) => {
                return (_openBlock(), _createBlock(ProductPriceCardComponent, {
                  key: item,
                  price: item,
                  "is-selected": isSelected(item),
                  "allow-select": __props.allowSelect,
                  onClick: ($event: any) => (onClick(item))
                }, null, 8, ["price", "is-selected", "allow-select", "onClick"]))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 512), [
        [_vShow, _additionPrices.value.length]
      ]),
      _withDirectives(_createVNode(SogCard, null, {
        default: _withCtx(() => [
          _createVNode(SogCardTitle, null, {
            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
              _createTextVNode(" Diverse ", -1)
            ]))]),
            _: 1
          }),
          _createVNode(SogCardContent, null, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_restPrices.value, (item) => {
                return (_openBlock(), _createBlock(ProductPriceCardComponent, {
                  key: item,
                  price: item,
                  "is-selected": isSelected(item),
                  "allow-select": __props.allowSelect,
                  onClick: ($event: any) => (onClick(item))
                }, null, 8, ["price", "is-selected", "allow-select", "onClick"]))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 512), [
        [_vShow, _restPrices.value.length]
      ])
    ]),
    _: 1
  }))
}
}

})